import { ItemRecapFollowOrder } from "./ItemRecapFollowOrder";

export default ItemRecapFollowOrder;
